exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.panel-default {\n  border-color: #BBB;\n  border-radius: 4px;\n}\n.panel-default .panel-heading {\n    background-color: #eee;\n    border-color: #ccc;\n    border-radius: 4px;\n}\n.actions {\n  margin: -5px;\n}\n.actions a {\n    margin-right: 5px;\n}\n.actions a button > span {\n      margin-right: 5px;\n}\n", ""]);

// exports
